import AutoComplete from './auto-complete';

export default AutoComplete;
